'use client'

import NextImage from 'next/image'
import { FC, useState } from 'react'

interface HoverAnimatedThumbnailProps {
  src: string
  animatedThumbnailUrl?: string | null
  alt: string
  fill?: boolean
  className?: string
  sizes?: string
  width?: number
  height?: number
  priority?: boolean
  quality?: number
}

const HoverAnimatedThumbnail: FC<HoverAnimatedThumbnailProps> = ({ src, animatedThumbnailUrl, alt, ...props }) => {
  const [isHovered, setIsHovered] = useState(false)

  const currentSrc = isHovered && animatedThumbnailUrl ? animatedThumbnailUrl : src

  return (
    <NextImage
      {...props}
      src={currentSrc}
      alt={alt}
      unoptimized={isHovered && !!animatedThumbnailUrl}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  )
}

export default HoverAnimatedThumbnail

/**
 * native <img> 向けのホバーハンドラー（埋め込みコンポーネント用）
 */
export function createThumbnailHoverHandlers(
  thumbnailUrl: string,
  animatedThumbnailUrl?: string | null,
): {
  onMouseEnter?: (e: React.MouseEvent<HTMLImageElement>) => void
  onMouseLeave?: (e: React.MouseEvent<HTMLImageElement>) => void
} {
  if (!animatedThumbnailUrl) return {}

  return {
    onMouseEnter: (e) => {
      ;(e.currentTarget as HTMLImageElement).src = animatedThumbnailUrl
    },
    onMouseLeave: (e) => {
      ;(e.currentTarget as HTMLImageElement).src = thumbnailUrl
    },
  }
}
